export const order = (length, current, steps = 1) => Math.abs((current + steps + length) % length);
